import { render } from "./LinesInThePressTop.vue?vue&type=template&id=c20cbc26"
import script from "./LinesInThePressTop.vue?vue&type=script&lang=js"
export * from "./LinesInThePressTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__